import {
  PaymentPlanServiceApiFactory,
  type ModelPaymentPlanPreviewRequest,
  type ModelPaymentPlanPreviewResponseMany,
  type ModelPaymentPlanRequest,
  type ModelPaymentPlanResponse,
} from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const generatePaymentPlanPreview = async (order: ModelPaymentPlanPreviewRequest) => {
  const client = createLayupClient();
  const response = await PaymentPlanServiceApiFactory(undefined, undefined, client).paymentPlanServiceCreatePreview({
    modelPaymentPlanPreviewRequest: order,
  });

  return response.data;
};

export const getPaymentPlan = async (id: string) => {
  const client = createLayupClient();
  const response = await client.get(`v1/payment-plan/${id}`);
  return response.data as ModelPaymentPlanResponse;
};

export const getPaymentPlanPreview = async (
  id: string,
  frequency = 'MONTHLY',
  offset?: number,
  paymentPlanId?: string,
) => {
  const client = createLayupClient();
  const response = await client.get(
    `v1/payment-plan/preview/${id}?frequency=${frequency}${offset != null ? `&offset=${offset}` : ''}${
      paymentPlanId != null ? `&paymentPlanId=${paymentPlanId}` : ''
    }`,
  );
  return response.data;
};

export const createPaymentPlan = async (paymentPlan: ModelPaymentPlanRequest) => {
  const client = createLayupClient(false);
  const response = await client.post('v1/payment-plan', paymentPlan);
  return response.data as ModelPaymentPlanResponse;
};

export const paymentPlanNotification = async (paymentPlanId: string): Promise<void> => {
  const client = createLayupClient(false);
  const request = JSON.stringify({
    _id: paymentPlanId,
  });
  await client.post('v1/payment-plan-send-notification', request);
};

export const createPaymentPlanPreview = async (
  payload: ModelPaymentPlanPreviewRequest,
): Promise<ModelPaymentPlanPreviewResponseMany> => {
  const client = createLayupClient(false);
  const response = await client.post('v1/payment-plan/preview', payload);
  return response.data as ModelPaymentPlanPreviewResponseMany;
};

export const sendStatementEmail = async (data: { orderId: string; paymentPlanId: string }) => {
  const client = createLayupClient(false);
  const response = await client.post('v1/statement', { ...data, type: 'email' });
  return response.data;
};
